import { Tag } from "primereact/tag";
import { Tooltip } from "primereact/tooltip";

import { FINANCEIRO_NO_VALUE, FINANCEIRO_TOOLTIP_PROPS } from "../../financeiro-obras.constants";
import type { FinanceiroStatusTagViewModel } from "./types-financeiro-status-tag";

/** Tag de status (tag/info do DS) com tooltip do nome completo, no hover e no foco. */
export function FinanceiroStatusTagView({
  isEmpty,
  label,
  tooltip,
  escopo,
  tooltipTarget,
  testId,
  className,
}: FinanceiroStatusTagViewModel) {
  if (isEmpty) return <>{FINANCEIRO_NO_VALUE}</>;

  return (
    <>
      <Tooltip target={tooltipTarget} {...FINANCEIRO_TOOLTIP_PROPS} />
      <Tag
        severity="info"
        className={className}
        tabIndex={0}
        aria-label={tooltip}
        data-financeiro-status={escopo}
        data-pr-tooltip={tooltip}
        data-testid={testId}
      >
        {label}
      </Tag>
    </>
  );
}
